export const createMaterialsActions = (state) => {
    const normalizeArray = (items) => (Array.isArray(items) ? [...items] : [])

    // --- Materials ---
    const setMaterials = (items) => {
        state.materials.value = normalizeArray(items)
    }

    const setMaterialsLoading = (value) => {
        state.materialsLoading.value = Boolean(value)
    }

    const setMaterialsFilters = (filters = {}) => {
        state.materialsFilters.value = {
            ...state.materialsFilters.value,
            ...filters
        }
    }

    const resetMaterialsFilters = () => {
        state.materialsFilters.value = state.createMaterialsFilters()
    }

    const setMaterialsMeta = (meta = {}) => {
        state.materialsMeta.value = {
            ...state.materialsMeta.value,
            ...meta
        }
    }

    const setMaterialTypes = (items) => {
        state.materialTypes.value = normalizeArray(items)
    }

    const setUnitsOfMeasure = (items) => {
        state.unitsOfMeasure.value = normalizeArray(items)
    }

    const setProductProductionProperties = (items) => {
        state.productProductionProperties.value = normalizeArray(items)
    }

    // --- Papers ---
    const setPapers = (items) => {
        state.papers.value = normalizeArray(items)
    }

    const setPapersLoading = (value) => {
        state.papersLoading.value = Boolean(value)
    }

    const setPapersFilters = (filters = {}) => {
        state.papersFilters.value = {
            ...state.papersFilters.value,
            ...filters
        }
    }

    const resetPapersFilters = () => {
        state.papersFilters.value = state.createPapersFilters()
    }

    const setPapersMeta = (meta = {}) => {
        state.papersMeta.value = {
            ...state.papersMeta.value,
            ...meta
        }
    }

    const getPaperById = (paperId) => {
        if (!paperId) return null
        return state.papers.value.find((paper) => paper?.id === paperId) ?? null
    }

    const setCoatingTypes = (items) => {
        state.coatingTypes.value = normalizeArray(items)
    }

    const setPrinergyPaperTypes = (items) => {
        state.prinergyPaperTypes.value = normalizeArray(items)
    }

    // --- Paper groups ---
    const setPaperGroups = (items) => {
        state.paperGroups.value = normalizeArray(items)
    }

    const setPaperGroupsLoading = (value) => {
        state.paperGroupsLoading.value = Boolean(value)
    }

    const setPaperGroupsFilters = (filters = {}) => {
        state.paperGroupsFilters.value = {
            ...state.paperGroupsFilters.value,
            ...filters
        }
    }

    const resetPaperGroupsFilters = () => {
        state.paperGroupsFilters.value = state.createPaperGroupsFilters()
    }

    const setPaperGroupsMeta = (meta = {}) => {
        state.paperGroupsMeta.value = {
            ...state.paperGroupsMeta.value,
            ...meta
        }
    }

    const getPaperGroupById = (paperGroupId) => {
        if (!paperGroupId) return null
        return state.paperGroups.value.find((group) => group?.id === paperGroupId) ?? null
    }

    // --- Import helpers ---
    const setImportProgress = (value) => {
        state.importProgress.value = Number.isFinite(value) ? Math.min(Math.max(value, 0), 100) : 0
    }

    const setImportInProgress = (value) => {
        state.importInProgress.value = Boolean(value)
    }

    const setImportAbortController = (controller) => {
        state.importAbortController.value = controller ?? null
    }

    const resetImportState = () => {
        setImportInProgress(false)
        setImportProgress(0)
        setImportAbortController(null)
    }

    return {
        // Materials
        setMaterials,
        setMaterialsLoading,
        setMaterialsFilters,
        resetMaterialsFilters,
        setMaterialsMeta,
        setMaterialTypes,
        setUnitsOfMeasure,
        setProductProductionProperties,

        // Papers
        setPapers,
        setPapersLoading,
        setPapersFilters,
        resetPapersFilters,
        setPapersMeta,
        getPaperById,
        setCoatingTypes,
        setPrinergyPaperTypes,

        // Paper groups
        setPaperGroups,
        setPaperGroupsLoading,
        setPaperGroupsFilters,
        resetPaperGroupsFilters,
        setPaperGroupsMeta,
        getPaperGroupById,

        // Import helpers
        setImportProgress,
        setImportInProgress,
        setImportAbortController,
        resetImportState
    }
}
